import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';

import { withAccount } from '../../../../components/AccountContext';
import SuperlinkImportList from './SuperlinkImportList';
import { parse, filterPaginationWithSize, emptyConnection } from '../../../../utils/UrlUtil';

export const LIST_QUERY = gql`
  query superlinkImportList(
    $accountId: ID!
    $superLinkId: ID!
    $first: Int
    $after: String
    $last: Int
    $before: String
    $filter: RespondentImportFilter
    $sort: RespondentImportSortSpecifier
  ) {
    account(id: $accountId) {
      id
      superLink(id: $superLinkId) {
        id
        respondentImports(first: $first, after: $after, last: $last, before: $before, filter: $filter, sort: $sort) {
          edges {
            node {
              id
              fileName
              status
              createdOn
              updatedOn
            }
          }
          pageInfo {
            startCursor
            endCursor
            hasPreviousPage
            hasNextPage
          }
          totalCount
          indexFrom
          indexTo
        }
      }
    }
  }
`;

class SuperlinkImportListContainer extends Component {
  render() {
    const {
      currentAccount, location, translatedTags, match,
    } = this.props;
    const params = parse(location.search);
    const pagination = filterPaginationWithSize(params);
    const { superLinkId } = match.params;
    const variables = {
      ...pagination,
      accountId: currentAccount,
      sort: params.sort,
      filter: params.filter,
      superLinkId,
    };
    return (
      <Query query={LIST_QUERY} variables={variables}>
        {({ data, loading, error }) => {
          if (error) {
            return `Error! ${error.message}`;
          }

          const connection = data && data.account && data.account.superLink
            ? data.account.superLink.respondentImports
            : emptyConnection();
          return (
            <SuperlinkImportList
              connection={connection}
              currentAccount={currentAccount}
              translatedTags={translatedTags}
              loading={loading}
            />
          );
        }}
      </Query>
    );
  }
}

SuperlinkImportListContainer.propTypes = {
  location: PropTypes.objectOf(PropTypes.any).isRequired,
  currentAccount: PropTypes.string.isRequired,
  translatedTags: PropTypes.arrayOf(PropTypes.any).isRequired,
  match: PropTypes.objectOf(PropTypes.any).isRequired,
};

const mapState = (state) => {
  const { translatedTags } = state.i18n;
  return {
    translatedTags,
  };
};

export default withRouter(
  injectIntl(
    connect(
      mapState,
      null,
    )(withAccount(SuperlinkImportListContainer)),
  ),
);
